<template>
    <select
        :class="styles.input"
        :multiple="multiple"
        @input="updateValue($event)"
    >
        <slot/>
    </select>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  emits: ['input'],
  data () {
    return {
      styles: window.myStyles
    }
  },

  methods: {
    updateValue (event) {
      const value = this.multiple ? Array.from(event.target.selectedOptions).map(option => option.value) : event.target.value
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>

</style>
